<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import shield_svg from '@img/guarantee/shield.svg';
import star_svg from '@img/guarantee/star.svg';
import clock_svg from '@img/guarantee/clock.svg';
import money_svg from '@img/guarantee/money.svg';
import delivery_svg from '@img/guarantee/delivery.svg';
import certificate_svg from '@img/guarantee/certificate.svg';
import InfoCards from "@js/components/InfoCards/Components/InfoCards.vue";
import PartnershipLayout from "@js/Shared/PartnershipLayout.vue";
import PopularCollectionsSlider from "@js/components/Sliders/PopularCollectionsSlider.vue";
import B2BSlider from "@js/components/Sections/B2B/B2BSlider.vue";
import b2bDesignerImg from "@img/callback/b2bdisegner.webp";
import {useCallbackStore} from "@js/store/CallbackStore.js";

export default defineComponent({
    layout: PartnershipLayout,
    name: "B2BForDesignersPage",
    components: {
        B2BSlider,
        PopularCollectionsSlider,
        InfoCards,
        Breadcrumbs,
        MobileTopBar,
    },
    data() {
        return {
            items_group_1: [
                {
                    logo: shield_svg,
                    title: 'Гарантия качества бетонных плит',
                    description: 'Мы производим бетонные плиты, которые соответствуют всем требованиям ГОСТ и проходят строгий контроль на каждом этапе производства. Прочные и долговечные плиты обеспечивают безопасность и надежность ваших строительных проектов.',
                },
                {
                    logo: certificate_svg,
                    title: 'Сертифицированные материалы',
                    description: 'Все наши бетонные плиты изготавливаются из высококачественных и экологически чистых материалов. Это гарантирует их устойчивость к нагрузкам, влаге и перепадам температур.',
                },
                {
                    logo: clock_svg,
                    title: 'Соблюдение сроков поставки',
                    description: 'Мы ценим ваше время, поэтому доставляем бетонные плиты точно в согласованные сроки. Благодаря профессиональной логистике и собственному автопарку доставка осуществляется быстро и без задержек.',
                }
            ],
            items_group_2: [
                {
                    logo: money_svg,
                    title: 'Прозрачные цены без скрытых доплат',
                    description: 'Вы всегда знаете точную стоимость бетонных плит заранее. Мы не добавляем скрытые комиссии, а также предлагаем выгодные условия для оптовых покупателей и постоянных клиентов.',
                },
                {
                    logo: delivery_svg,
                    title: 'Гарантия сохранности при доставке',
                    description: 'Наши бетонные плиты транспортируются в соответствии с требованиями безопасности, чтобы исключить повреждения в процессе доставки. Мы гарантируем, что продукция прибудет на ваш объект в идеальном состоянии.',
                },
                {
                    logo: star_svg,
                    title: 'Гарантийный срок на бетонные плиты',
                    description: 'Мы уверены в качестве нашей продукции и предоставляем гарантию на бетонные плиты. Это подтверждает их соответствие всем эксплуатационным нормам и требованиям.',
                }
            ],
        }
    },
    methods: {
        openForm(){
            this.callbackStore.showBaseCallbackPopup({
                title: 'Стать нашим партером',
                bitrix_title: 'Заявка на партнерство для дизайнеров',
                img_src: b2bDesignerImg,
            })
        }
    },
    setup() {
        const callbackStore = useCallbackStore()

        return {callbackStore}
    }
})
</script>

<template>
    <div class="bg-black pt-5 md:pt-10 pb-[150px] text-white">
        <div class="container">
            <div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
                    <div class="flex items-center justify-center">
                        <div>
                            <Breadcrumbs class="text-white"/>
                            <h1 class="text-2xl md:text-4xl font-bold mb-5">
                                B2B для Дизайнеров
                            </h1>
                            <p class="md:text-xl mb-5 md:max-w-[80%]">
                                Занимайтесь строительством, а мы сделаем так, чтобы для для вас это было надежно,
                                выгодно и
                                удобно.
                            </p>
                            <button @click.prevent="openForm"
                                class="flex max-md:w-full justify-center items-center text-black md:hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-14 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                                Стать партером
                            </button>
                        </div>
                    </div>
                    <div class="flex items-center justify-center">
                        <img src="@img/b2b/designers/top-bg.png"
                             class="max-h-[400px]"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="bg-white rounded-t-[25px] md:rounded-t-[50px] -mt-[100px]">
        <div class="container pt-10 md:pt-20">
            <h2 class="text-2xl md:text-3xl font-bold mb-5">
                Наши услуги для строителей
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5 md:mb-10">
                <div>
                    <div class="grid grid-cols-2 gap-3 md:gap-5 h-full">
                        <div
                            class="flex items-center justify-center bg-grayBg p-4 md:p-6 rounded-lg md:rounded-2xl font-semibold md:font-medium text-center text-sm md:text-base lg:text-xl">
                            <p>
                                ЗD визуализация для ваших клиентов (бесплатно).
                            </p>
                        </div>
                        <div
                            class="flex items-center justify-center bg-grayBg p-4 md:p-6 rounded-lg md:rounded-2xl font-semibold md:font-medium text-center text-sm md:text-base lg:text-xl">
                            <p>
                                Доставка образцов на адрес.
                            </p>
                        </div>
                        <div
                            class="flex items-center justify-center bg-grayBg p-4 md:p-6 rounded-lg md:rounded-2xl font-semibold md:font-medium text-center text-sm md:text-base lg:text-xl">
                            <p>
                                Подбор материалов по цене, цвету и фактуре.
                            </p>
                        </div>
                        <div
                            class="flex items-center justify-center bg-grayBg p-4 md:p-6 rounded-lg md:rounded-2xl font-semibold md:font-medium text-center text-sm md:text-base lg:text-xl">
                            <p>
                                Бесплатная доставка по Москве или до ТК.
                            </p>
                        </div>
                    </div>
                </div>
                <div>
                    <img src="@img/b2b/builders/main.webp"
                         class="object-contain"
                         alt="B2B для строителей" title="B2B для строителей"/>
                </div>
            </div>
        </div>
    </section>

    <InfoCards :items_group_1="items_group_1"
               :items_group_2="items_group_2"
               class="mb-5 md:mb-10"/>
    <div class="container">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5 md:mb-10">
            <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                <h2 class="text-2xl md:text-3xl font-bold mb-5">
                    Мы возьмем на себя часть Ваших забот
                </h2>
                <p class="mb-3">
                    Мы понимаем, что работа строителя сложна и насыщена сама по себе, помимо основной деятельности,
                    необходимо консультировать заказчиков в выборе отделочных материалов, а также решать организационные
                    вопросы.
                </p>
                <p class="mb-3">
                    Мы занимаемся продажей плитки уже 20 лет, и знаем, что необходимо покупателю.
                </p>
                <p class="mb-3">
                    Мы готовы взять на себя часть забот:
                </p>
                <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                    <li>
                        подбор керамической плитки по стилю, бюджету, техническим требованиям;
                    </li>
                    <li>
                        ЗD визуализация и раскладка по стенам;
                    </li>
                    <li>
                        комплектация и доставка материалов.
                    </li>
                </ul>
            </div>
            <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                ТУТ ЕЩЕ ТЕКСТ
            </div>
        </div>
    </div>
    <div class="max-md:ps-5 sm:container">
        <div class="mb-10">
            <h2 class="text-2xl font-semibold mb-6">
                Другие услуги B2B
            </h2>
            <B2BSlider/>
        </div>
    </div>
    <div class="container">
        <PopularCollectionsSlider/>
    </div>
</template>

<style scoped lang="scss">

</style>
